<template>
  <div>
    <v-container>
    <v-btn class="ma-1" v-for="state in states" :key="state.abbr" :to="{ name: 'state', params: { state: state.abbr }}">
        {{ state.name }}
    </v-btn>

      <v-row justify="start" no-gutters>
        <v-col v-for="center in dict[$route.params.state]" :key="center.slug" lg=3 md=4 sm=6 cols=12>
          <v-card class="pa-2 ma-1" :to="{ name: 'reg-form', params: { centerId: center.slug }}">
            <h4>{{ center.name }}</h4>
            {{ center.address }}<br>
            {{ center.city }}, {{ center.state }} {{ center.zip }}
          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </div>

</template>

<script>
import api from "../api.js"
// import centers from "../locations/locations.json"

export default {
  name: 'Centers',
  data() {
    return {
      states: [],
      centers: [],
      dict: {},
    }
  },
  mounted() {
    api.getCenters().then(result => {
      this.centers = result.data

      for(var center of this.centers) {
        if (this.dict[center.state] == null) {
          this.states.push({
            abbr: center.state,
            name: center.stateFullName
          })
          this.dict[center.state] = [center]
        }
        else this.dict[center.state].push(center)
      }
      this.states.sort(function(a, b) {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })
    })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
